export const FooterBottom = () => {
  return (
    <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
      <p>© 2024 Ekselencia. Todos los derechos reservados.</p>
      <p className="mt-2">Terra Incognita Creations LLC - Miami Beach, Florida, United States</p>
      <div className="mt-4 flex justify-center">
        <a href="https://terueltoday.com/directorio/" target="_blank" rel="noopener noreferrer">
          <img src="https://terueltoday.com/assets/sponsor_badge_round-b2XXpUoy.png" alt="Teruel Today Directorio" className="h-16 w-auto" loading="lazy" />
        </a>
      </div>
    </div>
  );
};
